import { useEffect } from "react";
import App from "./App";
import $ from 'jquery';

const RenderToIndex = () => {

    useEffect(() => {
      $("#pageloader-overlay").fadeOut(1000);
    }, [])
    
  return (
    <div>
      <div id="pageloader-overlay" className="visible incoming">
        <div className="loader-wrapper-outer">
          <div className="loader-wrapper-inner">
            <div className="loader"></div>
          </div>
        </div>
      </div>
      <div id="wrapper">
        <div className="fixedtop">
          <App />
          <div id="workdesk"></div>
        </div>
        {/* <div className="clearfix"></div> */}
      </div>
    </div>
  );
};

export default RenderToIndex;
